import ModelWithFacilityApi from "./ModelWithFacilityApi";


export default class EventsApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "events/";
	}

	list(facility, date, onSuccess, onError, expand = false){
		let endPoint = this.baseUrl + `?facility=${facility.split("/").slice(-2)[0]}&expand=${expand}`;
        if (date)
            endPoint = endPoint + "&date=" + date.toISOString().split('T')[0]

		this.Get(endPoint, onSuccess, onError)

	}
}
